import { Injectable, } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomSnackbarComponent } from '../../component/custom-snackbar/custom-snackbar.component';


@Injectable({
    providedIn: 'root'
})
export class SnackBarUtil {
    constructor(public snackBar: MatSnackBar) { }

    triggerSnackBar(data: any) {
        if (data.type === 'SUCCESS') {

            this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: { type: data.type, message: data.message },
                duration: 3000,
                horizontalPosition: 'right',
                verticalPosition: 'bottom',
                panelClass: 'custom-snackbar-container'
            });


        } else if (data.type === 'DOWNLOAD') {
            this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: { type: data.type, message: data.message },
                duration: 6000,
                horizontalPosition: 'right',
                verticalPosition: 'top',
                panelClass: 'custom-snackbar-container'
            });
        }
        else if (data.type === 'ERROR') {
            this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: { type: data.type, message: data.message },
                duration: 3000,
                horizontalPosition: 'right',
                verticalPosition: 'top',
                panelClass: 'custom-snackbar-container'
            });
        }
        else if (data.type === 'INFO') {
            this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: { type: data.type, message: data.message },
                duration: 2000,
                horizontalPosition: 'right',
                verticalPosition: 'bottom',
                panelClass: 'custom-snackbar-container'
            });
        }
        else if (data.type === 'WARNING') {
            this.snackBar.openFromComponent(CustomSnackbarComponent, {
                data: { type: data.type, message: data.message },
                duration: 3000,
                horizontalPosition: 'right',
                verticalPosition: 'bottom',
                panelClass: 'custom-snackbar-container'
            });
        }
    }
}